import {css, html, LitElement, PropertyValues} from 'lit';
import {customElement, property} from 'lit/decorators';
import {containerStyles, normalizeStyles} from '@webs/components-library/theming';
import {MainMenuItem} from '@webs/components-library/navigation-menu';
import {Logo} from '@webs/components-library/main-navigation';

@customElement('webs-navigation-mobile')
export class NavigationMobile extends LitElement {

  static styles = [
    normalizeStyles,
    containerStyles,
    css`
      .navigation { align-items: center;
        background: rgba(255,255,255,.1);
        display: flex;
        justify-content: space-between;
        padding: 1.5rem;
      }

      .navigation.active {
        background: var(--color-light-grey);
      }

      .navigation--scrolled:not(.active) {
        background: var(--color-white);
      }

      .navigation__mobile-trigger {
        align-items: flex-end;
        display: flex;
        flex-direction: column;
        height: 24px;
        justify-content: center;
        width: 30px;
      }

      .navigation__mobile-trigger::before,
      .navigation__mobile-trigger::after {
        background: var(--color-base);
        border-radius: 2px;
        content: '';
        display: block;
        height: 2px;
      }

      .navigation__mobile-trigger::before {
        width: 100%;
      }

      .navigation__mobile-trigger::after{
        margin-top: .4rem;
        width: 70%;
      }

      .navigation.active .navigation__mobile-trigger {
        height: 24px;
        position: relative;
        width: 24px;
        transform: rotate(45deg);
      }

      .navigation.active .navigation__mobile-trigger::before,
      .navigation.active .navigation__mobile-trigger::after {
        left: 50%;
        margin: 0;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
      }

      .navigation.active .navigation__mobile-trigger::before {
        transform: translate(-50%, -50%) rotate(90deg);
      }

      .navigation.active .navigation__mobile-trigger::after {
        transform: translate(-50%, -50%) ;
      }

      .navigation__menu {
        background: var(--color-light-grey);
        height: calc(100vh - 80px);
        justify-content: space-between;
        padding-bottom: 1rem;
        position: relative;
      }

      .navigation__menu.hidden {
        display: none;
      }

      .navigation__menu .container {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 0 1.5rem;
      }

      ::slotted(a) {
        color: var(--color-base);
        display: block;
        font-family: var(--font-family-alternative);
        font-size: .8rem;
        font-weight: var(--font-weight-semibold);
        margin: .5rem 0;
        padding: .5rem 0;
        text-decoration: none;
      }

      webs-navigation-menu {
        flex: 1;
        overflow: auto;
      }

      webs-navigation-menu::part(submenu) {
        width: 100%;
        height: 100%;
      }

      webs-button {
        display: block;
        max-width: 400px;
        margin: 0 auto;
      }

      webs-button::part(button) {
        width: 100%;
      }

      .navigation__actions {
        padding-top: 2rem;
      }

      .navigation__logo {
        position: relative;

      }


       .navigation__logo--no-claim {
        // position: absolute;
        // animation-name: fadein;
        // animation-duration: 1s;
        // animation-delay: 2s;
        // animation-fill-mode: both;
        // animation-timing-function: ease-in-out;
        // margin-top: -.5rem;

      }

       .navigation__logo--claim::part(img) {
        height: 200%;
      }

      // .navigation__logo--claim {
      //    margin-top: -1rem;
      //    position: absolute;
      //    animation-name: fadeout;
      //    animation-duration: 1s;
      //    animation-delay: 2s;
      //    animation-fill-mode: both;
      //    animation-timing-function: ease-in-out;
      // }

      @keyframes fadein {
          from { opacity: 0; }
          to   { opacity: 1; }
      }

      @keyframes fadeout {
          from { opacity: 1; }
          to   { opacity: 0; }
      }
    `
  ];

  private isActive: boolean;

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('scroll', () => {
      const navigation = this.shadowRoot.querySelector('[data-navigation]');
      if (navigation) {
        if (window.pageYOffset > 50) {
          navigation.classList.add('navigation--scrolled')
        } else {
          navigation.classList.remove('navigation--scrolled')
        }
      }
    });
  }

  @property({type: Object})
  logo: Logo;



  @property({attribute: 'main-cta'})
  cta: string;

  @property({attribute: 'main-cta-text'})
  ctaTitle: string;

  @property({attribute: 'hubspot-cta'})
  isHubspotCta: boolean;

  @property({attribute: 'menu', type: Array})
  menu: MainMenuItem[];



  protected render(): unknown {
    return html`

      <div class="navigation ${this.isActive ? 'active' : ''}" data-navigation>
        <div class="navigation__logo">
          ${this.logo && this.logo.src ? html`
            <webs-navigation-logo class="navigation__logo--claim" src="${this.logo.srcVariant}" alt="${this.logo.alt}" link="${this.logo.link}"></webs-navigation-logo>
          ` : ''}





        </div>

        <a class="navigation__mobile-trigger" href="javascript:;" @click="${this.toggleMenu}"></a>
      </div>

      <div class="navigation__menu ${!this.isActive ? 'hidden' : ''}">
        <div class="container">
          <webs-navigation-menu .items="${this.menu}"></webs-navigation-menu>

          <div class="navigation__actions">
            ${this.cta ? this.isHubspotCta ? html`
              ${this.cta}
            ` : html`
              <webs-button href="${this.cta}" text="${this.ctaTitle}" type="main-cta"></webs-button>
            ` : ''}

            <slot name="actions"></slot>
          </div>
        </div>
      </div>
    `;
  }

  private toggleMenu(event: Event): void {
    this.isActive = !this.isActive;
    this.requestUpdate();
  }




}
